import { PaymentSummaryInfo } from 'src/app/pages/new-subscribe-plans/store/model';

export class SetCheckoutSuccessInfo {
  static type = '[New SubscribePlans] Checkout success info';

  constructor(public data: PaymentSummaryInfo) {
  }
}
